import { render, staticRenderFns } from "./StaffMember.vue?vue&type=template&id=5cfa9e9e"
import script from "./StaffMember.vue?vue&type=script&lang=js"
export * from "./StaffMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports